module.exports = __webpack_public_path__ + "img/symbol_1.4131b62e.png";